import React from 'react';
import { Headline } from './article/Headline';
import { Byline } from './article/Byline';
import { OpeningSection } from './article/OpeningSection';
import { ProblemReveal } from './article/ProblemReveal';
import { ProductIntroduction } from './article/ProductIntroduction';
import { FiveReasons } from './article/FiveReasons';
import { TestingSection } from './article/TestingSection';
import { DeliverySection } from './article/DeliverySection';
import { BeyondWrinkles } from './article/BeyondWrinkles';
import { FinalVerdict } from './article/FinalVerdict';
import { HighlightBox } from './article/HighlightBox';
import { HowToGet } from './article/HowToGet';
import { GuaranteeBox } from './article/GuaranteeBox';
import { LimitedAvailability } from './article/LimitedAvailability';
import { CustomerReviews } from './article/CustomerReviews';
import { FinalClose } from './article/FinalClose';
import { Footer } from './article/Footer';
export function ArticleContent() {
  return <article className="bg-white rounded-lg shadow-sm md:p-8 space-y-8" data-id="element-308">
      <Headline data-id="element-309" />
      <Byline data-id="element-310" />
      <OpeningSection data-id="element-311" />
      <ProblemReveal data-id="element-312" />
      <ProductIntroduction data-id="element-313" />
      <FiveReasons data-id="element-314" />
      <TestingSection data-id="element-315" />
      <DeliverySection data-id="element-316" />
      <BeyondWrinkles data-id="element-317" />
      <FinalVerdict data-id="element-318" />
      <HighlightBox data-id="element-319" />
      <HowToGet data-id="element-320" />
      <GuaranteeBox data-id="element-321" />
      <LimitedAvailability data-id="element-322" />
      <CustomerReviews data-id="element-323" />
      <FinalClose data-id="element-324" />
      <Footer data-id="element-325" />
    </article>;
}